import React from 'react';
import { Button } from './Button';
import { Icon } from './Icon';
import { useLanguage } from '../contexts/LanguageContext';
export function Gallery() {
  const {
    t
  } = useLanguage();
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/rfvrNZA6QFevmPKKdBzmH8/IMG_5995.JPG.jpg',
    alt: 'Alexaaa Narvaez - Alta Moda',
    categoryKey: 'gallery.category1'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/pUXVahmqVccsp1oLQ6FBMM/IMG_6519.JPG.jpg',
    alt: 'Alexaaa Narvaez - Editorial',
    categoryKey: 'gallery.category2'
  }];
  return <section id="galeria" className="py-20 md:py-32 px-6 bg-[#0a0a0a]" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        {/* Header - Centered */}
        <div className="text-center mb-16 md:mb-20" data-id="element-90">
          <span className="inline-block text-[#C5A028] text-xs font-medium tracking-[0.2em] uppercase mb-4" data-id="element-91">
            {t('gallery.label')}
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mb-5 tracking-tight leading-tight" data-id="element-92">
            {t('gallery.title')}
          </h2>
          <p className="text-white/50 font-light max-w-xl mx-auto leading-relaxed text-sm md:text-base" data-id="element-93">
            {t('gallery.subtitle')}
          </p>
          <div className="w-20 h-px bg-gradient-to-r from-transparent via-[#C5A028]/40 to-transparent mx-auto mt-6" data-id="element-94" />
        </div>

        {/* Gallery Grid - Editorial Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 mb-16 md:mb-20" data-id="element-95">
          {images.map((image, index) => <div key={index} className="group relative aspect-[3/4] overflow-hidden rounded-sm animate-slide-up" style={{
          animationDelay: `${index * 0.15}s`
        }} data-id="element-96">
              {/* Image with Balanced Editorial Treatment */}
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105" style={{
            filter: 'brightness(1.05) contrast(1.05) saturate(1.0)'
          }} data-id="element-97" />

              {/* Lighter Permanent Overlay - Much more subtle */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/10" data-id="element-98" />

              {/* Enhanced Overlay on Hover */}
              <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-all duration-500" data-id="element-99" />

              {/* Editorial Frame */}
              <div className="absolute inset-0 border border-white/10" data-id="element-100" />

              {/* Category Badge - Always Visible */}
              <div className="absolute top-6 left-6 transition-all duration-500" data-id="element-101">
                <span className="bg-black/50 backdrop-blur-sm border border-[#C5A028]/30 text-[#C5A028] text-xs font-medium tracking-wider px-4 py-2 rounded-sm" data-id="element-102">
                  {t(image.categoryKey)}
                </span>
              </div>

              {/* Hover Icon */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500" data-id="element-103">
                <div className="w-16 h-16 rounded-full bg-black/40 backdrop-blur-md flex items-center justify-center border border-white/20 transform scale-75 group-hover:scale-100 transition-transform duration-500" data-id="element-104">
                  <Icon name="arrow-right" size={20} className="text-white" data-id="element-105" />
                </div>
              </div>
            </div>)}
        </div>

        {/* CTA - Centered, Full Width on Mobile */}
        <div className="text-center" data-id="element-106">
          <div className="flex justify-center" data-id="element-107">
            <Button href="https://backstage.cam/u/alexaaa-narvaez" variant="primary" className="w-full md:w-auto" data-id="element-108">
              <span className="mr-2" data-id="element-109">{t('gallery.cta')}</span>
              <Icon name="arrow-right" size={16} data-id="element-110" />
            </Button>
          </div>
          <p className="text-white/40 text-xs md:text-sm mt-5 font-light" data-id="element-111">
            {t('gallery.ctaSubtext')}
          </p>
        </div>
      </div>
    </section>;
}